import { render, staticRenderFns } from "./CredencialesProveedor.vue?vue&type=template&id=0c5ba428&scoped=true"
import script from "./CredencialesProveedor.vue?vue&type=script&lang=js"
export * from "./CredencialesProveedor.vue?vue&type=script&lang=js"
import style0 from "./CredencialesProveedor.vue?vue&type=style&index=0&id=0c5ba428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ba428",
  null
  
)

export default component.exports